// loginJourney.js - MWDH theme-specific login journey functionality
$(document).ready(function () {
    // Only run on pages with login journey elements
    if ($('.login-journey__input-group').length === 0) return;

    /**
     * Helper function to append query parameters to a URL
     * @param {string} url - The base URL to append parameters to
     * @param {Object} params - Object containing parameter key-value pairs
     * @return {string} - The URL with appended query parameters
     */
    function appendQueryParams(url, params) {
        var urlObj = new URL(url, window.location.origin);

        Object.keys(params).forEach(function (key) {
            if (params[key]) {
                urlObj.searchParams.append(key, params[key]);
            }
        });

        return urlObj.toString();
    }

    // Get all dropdown elements and their container groups using label text
    var countryGroup = $('.login-journey__input-group').filter(function () {
        return $(this).find('p').text().trim() === 'Country:';
    });
    var countryDropdown = countryGroup.find('select');

    var nationGroup = $('.login-journey__input-group').filter(function () {
        return $(this).find('p').text().trim() === 'Nation:';
    });
    var nationDropdown = nationGroup.find('select');

    var countyGroup = $('.login-journey__input-group').filter(function () {
        return $(this).find('p').text().trim() === 'County:';
    });
    var countyDropdown = countyGroup.find('select');

    var boroughGroup = $('.login-journey__input-group').filter(function () {
        return $(this).find('p').text().trim() === 'Borough:';
    });
    var boroughDropdown = boroughGroup.find('select');

    // Initially hide all dependent dropdown groups except country
    nationGroup.removeClass('is-active');
    countyGroup.removeClass('is-active');
    boroughGroup.removeClass('is-active');

    /**
     * Reset and disable all dependent dropdowns
     * @param {jQuery} startDropdown - The dropdown from which to start disabling
     */
    function resetDependentDropdowns(startDropdown) {
        if (startDropdown === nationDropdown || startDropdown === null) {
            nationDropdown.val('').prop('disabled', true);
            nationGroup.removeClass('is-active');

            countyDropdown.val('').prop('disabled', true);
            countyGroup.removeClass('is-active');

            boroughDropdown.val('').prop('disabled', true);
            boroughGroup.removeClass('is-active');
        } else if (startDropdown === countyDropdown) {
            countyDropdown.val('').prop('disabled', true);
            countyGroup.removeClass('is-active');

            boroughDropdown.val('').prop('disabled', true);
            boroughGroup.removeClass('is-active');
        } else if (startDropdown === boroughDropdown) {
            boroughDropdown.val('').prop('disabled', true);
            boroughGroup.removeClass('is-active');
        }
    }

    /**
     * Initialize dropdown state based on current values
     * Called on page load and when the page is restored from browser history
     */
    function initializeDropdownState(isBackNavigation) {
        if (isBackNavigation) {
            // Reset all UI sections to their initial hidden state
            $('.login-journey__section--bottom').addClass('login-journey-hidden');
            $('.login-journey__container--media').addClass('login-journey-hidden');

            var countryValue = countryDropdown.val();
            var nationValue = nationDropdown.val();
            var countyValue = countyDropdown.val();

            // Reset all dependent dropdowns
            resetDependentDropdowns(null);

            // Cascade based on current dropdown values
            if (countryValue && countryValue !== '' && countryValue === 'United Kingdom') {
                nationDropdown.prop('disabled', false);
                nationGroup.addClass('is-active');

                if (nationValue && nationValue !== '') {
                    if (nationValue === 'England') {
                        $('.login-journey__container--media').removeClass('login-journey-hidden');

                        countyDropdown.prop('disabled', false);
                        countyGroup.addClass('is-active');

                        if (countyValue && countyValue !== '' && countyValue === 'Greater London') {
                            boroughDropdown.prop('disabled', false);
                            boroughGroup.addClass('is-active');
                        }
                    }
                }
            }
        } else {
            // Normal initialization - reset everything
            countryDropdown.val('').prop('selectedIndex', 0);
            resetDependentDropdowns(null);
        }
    }

    // Country dropdown change handler
    countryDropdown.on('change', function () {
        var selectedCountry = $(this).val();
        var selectedOption = $(this).find('option:selected');
        var redirectUrl = selectedOption.data('redirecturl');
        var signupType = selectedOption.data('signuptype');
        var lang = selectedOption.data('lang');

        // Non-UK countries with redirect URL
        if (redirectUrl) {
            var params = {
                referrerSite: 'MWDH',
                countrySelect: encodeURIComponent(selectedCountry)
            };

            if (signupType) {
                params.sign_up_type = encodeURIComponent(signupType);
            }
            if (lang) {
                params.lang = encodeURIComponent(lang);
            }

            var finalUrl = appendQueryParams(redirectUrl, params);

            setTimeout(function () {
                window.location.href = finalUrl;
            }, 500);

            return;
        }

        // Reset all dependent dropdowns
        resetDependentDropdowns(nationDropdown);

        // If United Kingdom is selected, enable the Nation dropdown and show media
        if (selectedCountry === 'United Kingdom') {
            nationDropdown.prop('disabled', false);
            nationGroup.addClass('is-active');
            $('.login-journey__container--media').removeClass('login-journey-hidden');
        } else {
            // Hide media container if not UK (e.g. switching from UK to another country)
            $('.login-journey__container--media').addClass('login-journey-hidden');
        }
    });

    // Nation dropdown change handler
    nationDropdown.on('change', function () {
        var selectedNation = $(this).val();
        var selectedOption = $(this).find('option:selected');
        var redirectUrl = selectedOption.data('redirecturl');
        var signupType = selectedOption.data('signuptype');

        // Show media container when England is selected
        if (selectedNation === 'England') {
            $('.login-journey__container--media').removeClass('login-journey-hidden');
        } else {
            $('.login-journey__container--media').addClass('login-journey-hidden');
        }

        // Scotland, Wales, Northern Ireland have redirect URLs
        if (redirectUrl) {
            var params = {
                referrerSite: 'MWDH',
                countrySelect: 'united_kingdom',
                nationSelect: encodeURIComponent(selectedNation)
            };

            if (signupType) {
                params.sign_up_type = encodeURIComponent(signupType);
            }

            var finalUrl = appendQueryParams(redirectUrl, params);

            setTimeout(function () {
                window.location.href = finalUrl;
            }, 500);

            return;
        }

        // Reset dependent dropdowns
        resetDependentDropdowns(countyDropdown);

        // If England is selected, enable the County dropdown
        if (selectedNation) {
            countyDropdown.prop('disabled', false);
            countyGroup.addClass('is-active');
        }
    });

    // County dropdown change handler
    countyDropdown.on('change', function () {
        var selectedCounty = $(this).val();
        var selectedOption = $(this).find('option:selected');
        var redirectUrl = selectedOption.data('redirecturl');
        var signupType = selectedOption.data('signuptype');

        // Counties with redirect URLs (Bedfordshire, Berkshire, etc.)
        if (redirectUrl) {
            var params = {
                referrerSite: 'MWDH',
                countrySelect: 'united_kingdom',
                nationSelect: 'England',
                countySelect: encodeURIComponent(selectedCounty)
            };

            if (signupType) {
                params.sign_up_type = encodeURIComponent(signupType);
            }

            var finalUrl = appendQueryParams(redirectUrl, params);

            setTimeout(function () {
                window.location.href = finalUrl;
            }, 500);

            return;
        }

        // Reset Borough dropdown
        resetDependentDropdowns(boroughDropdown);

        // If Greater London is selected, enable the Borough dropdown
        if (selectedCounty) {
            boroughDropdown.prop('disabled', false);
            boroughGroup.addClass('is-active');
        }
    });

    // Borough dropdown change handler
    boroughDropdown.on('change', function () {
        var selectedBorough = $(this).val();
        var selectedOption = $(this).find('option:selected');
        var redirectUrl = selectedOption.data('redirecturl');
        var signupType = selectedOption.data('signuptype');

        // Boroughs that show the bottom section with service images
        var specialBoroughs = [
            'Brent',
            'Ealing',
            'Hammersmith and Fulham',
            'Harrow',
            'Hillingdon',
            'Hounslow',
            'Kensington and Chelsea',
            'Westminster'
        ];

        if (specialBoroughs.indexOf(selectedBorough) !== -1) {
            $('.login-journey__section--bottom').removeClass('login-journey-hidden');
            $('.login-journey__container--media').addClass('login-journey-hidden');
            return;
        }

        // Hide the bottom section for non-special boroughs
        $('.login-journey__section--bottom').addClass('login-journey-hidden');

        // Non-special boroughs with redirect URLs
        if (redirectUrl) {
            var params = {
                referrerSite: 'MWDH',
                countrySelect: 'united_kingdom',
                nationSelect: 'England',
                countySelect: 'Greater London',
                boroughSelect: encodeURIComponent(selectedBorough)
            };

            if (signupType) {
                params.sign_up_type = encodeURIComponent(signupType);
            }

            var finalUrl = appendQueryParams(redirectUrl, params);

            setTimeout(function () {
                window.location.href = finalUrl;
            }, 500);
        }
    });

    // Browser back button support
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            setTimeout(function () { initializeDropdownState(true); }, 250);
        }
    });

    window.addEventListener('popstate', function () {
        setTimeout(function () { initializeDropdownState(true); }, 250);
    });

    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
            var countryValue = countryDropdown.val();
            if (countryValue && countryValue !== '' && countryValue === 'United Kingdom') {
                initializeDropdownState(true);
            }
        }, 100);
    });

    // Initial state setup
    initializeDropdownState(false);
});
